import React, { useEffect } from 'react';
import { HiArrowNarrowRight } from 'react-icons/hi';
import avatar from '../assets/ava.png'
import TypeWriterEffect from 'react-typewriter-effect';
import { Link } from 'react-scroll';
import {
  FaGithub,
  FaLinkedin,
  FaWhatsapp,
} from 'react-icons/fa';
import { BsFillPersonLinesFill } from 'react-icons/bs';
import AOS from 'aos'
import 'aos/dist/aos.css'

const Home = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);
  return (
    <div name='home' className='w-full h-screen bg-[#0a192f] flex'>
      {/* Container */}
      <div className='mx-auto container w-full h-screen flex' data-aos='zoom-in'>
        <div className='hidden lg:flex h-full w-[30%] items-center justify-center'>
          <img src={avatar} alt='avatar' className='border-white border-4 rounded-full ml-[6rem]' style={{ width: '250px', height: '250px' }} />
        </div>
        <div className='max-w-[1000px] mx-auto px-7 flex flex-col justify-center h-full'>
          <p className='text-pink-600'>Hi, my name is</p>
          <h1 className='text-2xl sm:text-7xl font-bold text-[#ccd6f6]'>
            RYAN AGUNG SAMUDRA
          </h1>
          <h1 className='text-xl sm:text-3xl font-bold text-[#8892b0]'>
            <TypeWriterEffect
              textStyle={{
                // color: '#ccd6f6',
                // fontWeight: 700,
                // fontSize: '4.5em',
              }}
              startDelay={2000}
              cursorColor="#3F3D56"
              multiText={[
                'Full Stack Developer',
                'Geomatics Engineer',
                'Virtual Tour Creator',
              ]}
              multiTextDelay={2500}
              typeSpeed={120}
              multiTextLoop
            />
          </h1>
          <div className='flex flex-wrap w-full justify-center py-6 md:hidden'>
            <div className='flex w-full justify-center'>
              <img src={avatar} alt='avatar' className='border-white border-4 rounded-full' style={{ width: '200px', height: '200px' }} />
            </div>
            <div className='flex w-[65%] justify-around mt-[2.5rem]'>
              <a href='https://www.linkedin.com/in/ryanagungsamudra' target='blank'>
                <FaLinkedin size={30} color='white' />
              </a>
              <a href='http://github.com/ryanagungsamudra' target='blank'>
                <FaGithub size={30} color='white' />
              </a>
              <a href='https://wa.me/6282284798890' target='blank'>
                <FaWhatsapp size={30} color='white' />
              </a>
              <label htmlFor="cv-modal-mobile">
                <BsFillPersonLinesFill size={30} color='white' />
              </label>
              <input type="checkbox" id="cv-modal-mobile" className="modal-toggle" />
              <label htmlFor="cv-modal-mobile" className="modal cursor-pointer">
                <label className="modal-box relative max-w-[832px] p-0 rounded-none" htmlFor="">
                  <iframe title='cv' src="https://drive.google.com/file/d/1mSVmCfJ-Jq_he6-1B_E58cirH5sjkHZS/preview" width="832" height="480" allow="autoplay"></iframe>
                </label>
              </label>
            </div>
          </div>
          <p className='text-[#8892b0] py-4 max-w-[700px]'>
            I’m a full-stack developer specializing in web and mobile. Experienced making 360 degree panoramic Virtual Tour applications. Currently, I’m focused on
            building responsive full-stack web applications.
          </p>
          <div>
            <Link to='work' smooth={true} duration={500}>
              <button className='text-white group border-2 px-6 py-3 my-2 flex items-center hover:bg-pink-600 hover:border-pink-600'>
                View Work
                <span className='group-hover:rotate-90 duration-300'>
                  <HiArrowNarrowRight className='ml-3 ' />
                </span>
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
